<div class="global-toolbar">
	<p-toolbar>
		<ng-template #start />

		<ng-template #center>
			<app-global-qr />
			<!-- <button
				pButton
				pTooltip="Chatear con Capy IA"
				tooltipPosition="top"
				[outlined]="true"
				class="p-button-rounded p-button-text flex flex-col items-center justify-center"
				(click)="goToCapyIA()"
			>
				<i class="pi pi-comments text-[20px]"></i>
				<span class="text-[10px]">Capy IA</span>
			</button> -->
		</ng-template>

		<ng-template #end> </ng-template>
	</p-toolbar>
</div>
